import { Inject, Injectable } from '@angular/core';


import { DataService } from 'src/app/core/services/data.service';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class OnDisplayService {

constructor(private dataSrv: DataService, private utils: UtilsService, private http: HttpClient) { }

saveUserTime(payload: any) {
	const formData = this.utils.jsonToFormData(payload);
	const url = `${environment.api}ondisplay/save_user_time`;

	return this.http.post(url, formData).subscribe({
		next: (res) => {
			console.info('Tiempo guardado:', res);
		},
		error: (err) => {
			console.error('Error guardando tiempo:', err);
		}
	});
}


updateStartTime(user_id: number, new_timestamp: number, date: string, campaign_id: number){
    const url = environment.api + "ondisplay/update_start_time.php";
    return this.dataSrv.post(url,{ user_id: user_id, new_timestamp: new_timestamp , date: date, campaign_id: campaign_id });
}

isThereCampaignTimer(user_id: number, new_timestamp: number, date: string, campaign_id: number){
    const url = environment.api + "ondisplay/is_there_campaign_timer.php";
    return this.dataSrv.post(url,{user_id: user_id, new_timestamp: new_timestamp , date: date, campaign_id: campaign_id });
}

getTimeSupplied(campaign_id: number, order_start_date: string){
    const url = environment.api + "ondisplay/get_time_supplied.php";
    return this.dataSrv.post(url,{ campaign_id: campaign_id, order_start_date: order_start_date});
}


}
